<template>
  <button
    v-if="!uiFlags.isOpen && callInfo.id"
    class="topnav-item w-9 h-9 p-0 flex items-center justify-center rounded-lg relative transition-colors duration-150 flex-shrink-0"
    @click="openWebphone"
  >
    <fluent-icon icon="call" />
    <div
      class="radar-ping-animation absolute top-0 right-0 -mt-1 -mr-1 rounded-full w-3 h-3 bg-woot-500 dark:bg-woot-500"
    />
    <div
      class="absolute top-0 right-0 -mt-1 -mr-1 rounded-full w-3 h-3 bg-woot-500 dark:bg-woot-500 opacity-50"
    />
  </button>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      uiFlags: 'webphone/getUIFlags',
      callInfo: 'webphone/getCallInfo',
    }),
  },
  methods: {
    openWebphone() {
      this.$store.dispatch('webphone/updateWebphoneVisible', {
        isOpen: true,
      });
    },
  },
};
</script>

<style scoped>
@tailwind components;
@layer components {
  /* Radar ping animation */
  @keyframes ping {
    75%,
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
  .radar-ping-animation {
    animation: ping 1s ease infinite;
  }
}
</style>
